import React, {useState} from "react";
import Modal from '../../../../../components-new/ui/Modal';
import config from "../../../../../config";
import {generalModalStyles} from "../../../../../utils/General";
import {t} from "../../../../../components/Translate";
import Translate from "../../../../../components/Translate";
import Input from "../../../../../components-new/form/Input";
import TranslateProperty from "../../../../../components/TranslateProperty";
import BlueButton from "../../../../../components-new/buttons/BlueButton";
import SilverButton from "../../../../../components-new/buttons/SilverButton";
import {endUnmanagedConversationsWithMessage} from "../../../../../services/company/api";
import DropdownSelect from "../../../../../components-new/form/DropdownSelect";
import PowerIcon from "../../../../../assets/icons/PowerIcon";
import './ChatActionModals.css';

const customStyles = {
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: '10px',
    },
};

const CloseChatsModal = ({isOpen, onRequestClose, addNotification, company, clients, user}) => {
    const [endChatText, setEndChatText] = useState("");
    const [endMin, setEndMin] = useState(0);
    const [selectedClient, setSelectedClient] = useState("");
    const [isSending, setIsSending] = useState(false);

    const clientOptions = [
        {id: "", name: t({text: 'allBots', user})},
        ...clients.map((c) => ({id: c.id, name: c.name})),
    ];

    const handleClose = () => {
        setEndChatText("");
        setEndMin(0);
        setSelectedClient("");
        onRequestClose();
    };

    const handleEndAndSendClick = () => {
        setIsSending(true);

        endUnmanagedConversationsWithMessage(
            company.id,
            endChatText,
            endMin,
            selectedClient
        )
            .then(() => {
                addNotification("successful", config.notificationLevels.success);
                handleClose();
            })
            .catch(() => {
                addNotification("somethingWentWrong", config.notificationLevels.error);
            })
            .finally(() => setIsSending(false));
    };

    return (
        <Modal
            closeTimeoutMS={config.closeTimeoutMS}
            isOpen={isOpen}
            onRequestClose={handleClose}
            style={generalModalStyles.convHeaderModalStyles}
            title={<Translate text="unmanagedChatsEndSettingHeader"/>}
            headerIcon={<PowerIcon width={20} height={20} stroke="var(--ds-fg-secondary)"/>}
            headerSeparator
            footerSeparator
            footer={<React.Fragment>
                <SilverButton type="button" width="auto" height="40px" onClick={handleClose} disabled={isSending}>
                    <Translate text="close"/>
                </SilverButton>
                <BlueButton type="button" width="auto" height="40px" onClick={handleEndAndSendClick}
                            disabled={isSending}>
                    <Translate text="endChats"/>
                </BlueButton>
            </React.Fragment>}
        >
            <div style={customStyles.container}>
                <p className="chat-action-modal__supporting-text">
                    <Translate text="chatsFunctionInfo"/>
                </p>

                <DropdownSelect
                    selectedValue={clientOptions.find((o) => o.id === selectedClient)}
                    options={clientOptions.map((o) => ({
                        value: o.id,
                        label: o.name,
                    }))}
                    onChange={(v) => setSelectedClient(v.value)}
                    styles={{width: "100%"}}
                    variant={"outline"}
                    childStyles={{height: '150px'}}
                />

                <Input
                    type="number"
                    name="interval"
                    value={endMin}
                    style={{width: "100%"}}
                    onChange={(e) => setEndMin(Math.max(0, Number(e.target.value)))}
                    min={0}
                />

                <TranslateProperty properties={[{key: "placeholder", value: "message"}]}>
                    <Input
                        name="message"
                        value={endChatText}
                        style={{width: "100%", minHeight: '240px'}}
                        onChange={(e) => setEndChatText(e.target.value)}
                        isTextarea={true}
                        resize={"vertical"}
                    />
                </TranslateProperty>

            </div>
        </Modal>
    );
};

export default CloseChatsModal;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/chat/chat-components/CloseChatsModal.jsx